"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return AIColumn;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _LongTextColumn = /*#__PURE__*/ _interop_require_default(require("~/models/LongTextColumn"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let AIColumn = class AIColumn extends _LongTextColumn.default {
    static castType(data) {
        return data && new AIColumn(data);
    }
    static async insert(context, aiColumn, ncMeta = _Noco.default.ncMeta) {
        return this._insert(context, aiColumn, [
            'fk_integration_id',
            'model',
            'prompt',
            'prompt_raw',
            'error'
        ], ncMeta);
    }
    static async update(context, columnId, aiColumn, ncMeta = _Noco.default.ncMeta) {
        return this._update(context, columnId, aiColumn, [
            'fk_integration_id',
            'model',
            'prompt',
            'prompt_raw',
            'error'
        ], ncMeta);
    }
};
